/**
 * region for libraries*/
import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import _ from "lodash";
import {
  Grid,
  TextField,
  Paper,
  Button,
  Menu,
  MenuItem,
  Checkbox,
  Divider,
  ListItemText,
  InputAdornment,
} from "@material-ui/core";

import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import Autocomplete from "@material-ui/lab/Autocomplete";
import SearchOutlined from "@material-ui/icons/SearchOutlined";

/**
 * region for redux*/
import { connect } from "react-redux";
import { IdentifySupplierJobsActions } from "../../actions/IdentifySupplierJobsActions";

/**
 * region for styles*/
import { filterIdentifySupplierJobsStyle } from "./style/filterIdentifySupplierJobsStyle";

/**
 * region for hepers*/
import Constants from "../../constants/Constants";
import typing from "../../helpers/typing";
import { Fragment } from "react";

const checkicon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

class FilterIdentifySupplierJobs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: Constants.MODE_LOADED,
      anchorEl: null,
      filters: {
        domain: "",
        categories: [],
        keywords: [],
        keywordsFound: [],
        locations: [],
        supplier: null,
        idStatus: Constants.SUPPLIER_JOB_STATUS_ENUM.New,
        beginDate:"",
        endDate:"",
        page:1,
        pageSize:10,
      },
      textDate: "Last 7 days",
    };
  }

  componentDidMount() {
    let self = this;
    let setFilters = self.props.filters;
    self.setState({ filters: setFilters });
  }

  handleOnChangeRefreshResultListDebounce = _.debounce((filters) => {
    let self = this;

    self.setState({ anchorEl: null }, function () {
      self.props.setFiltersAndGetList(filters);
    });
  }, 1000);

  handleOnInputChangeAutocompleteCategoryDebounce = _.debounce((self, text) => {
    self.props.getCategories(text);
  }, 1000);

  handleOnInputChangeAutocompleteKeywordDebounce = _.debounce((self, text) => {
    self.props.getKeywords(text);
  }, 1000);

  handleOnInputChangeAutocompleteKeywordFoundDebounce = _.debounce(
    (self, text) => {
      self.props.getKeywordsFound(text);
    },
    1000
  );

  handleOnChangeTextFieldSearch(event) {
    let self = this;
    let setFilters = self.state.filters;
    const domain = {
      domain: event.target.value,
    };
    Object.assign(setFilters, domain);
    self.setState({ filters: setFilters });
  }
  keywordsFound;

  handleOnKeyDownTextFieldSearch(event) {
    let self = this;
    if (event.keyCode === 13) {
      let setFilters = self.state.filters;
      const domain = {
        domain: event.target.value,
      };
      Object.assign(setFilters, domain);
      self.setState({ filters: setFilters }, function () {
        self.handleOnChangeRefreshResultListDebounce(self.state.filters);
      });
    }
  }

  handleOnInputChangeAutocompleteKeyword(event) {
    let self = this;
    self.handleOnInputChangeAutocompleteKeywordDebounce(
      self,
      event.target.value
    );
  }

  handleOnInputChangeAutocompleteKeywordFound(event) {
    let self = this;
    self.handleOnInputChangeAutocompleteKeywordFoundDebounce(
      self,
      event.target.value
    );
  }

  handleOnChangeAutocompleteKeyword(event, items) {
    let self = this;
    let setFilters = self.state.filters;
    const keywords = {
      keywords: items,
    };
    Object.assign(setFilters, keywords);

    const page = {
      page: 1,
    };
    Object.assign(setFilters, page);

    self.setState({ filters: setFilters });
  }

  handleOnChangeAutocompleteKeywordFound(event, items) {
    let self = this;
    let setFilters = self.state.filters;
    const keywordsFound = {
      keywordsFound: items,
    };
    Object.assign(setFilters, keywordsFound);

    const page = {
      page: 1,
    };
    Object.assign(setFilters, page);
    self.setState({ filters: setFilters });
  }

  handleOnInputChangeAutocompleteCategory(event) {
    let self = this;
    self.handleOnInputChangeAutocompleteCategoryDebounce(
      self,
      event.target.value
    );
  }

  handleOnChangeAutocompleteCategory(event, items) {
    let self = this;
    let setFilters = self.state.filters;
    const categories = {
      categories: items,
    };
    Object.assign(setFilters, categories);

    const page = {
      page: 1,
    };
    Object.assign(setFilters, page);

    self.setState({ filters: setFilters });
  }

  handleOnChangeAutocompleteLocations(event, items) {
    let self = this;
    let setFilters = self.state.filters;
    const locations = {
      locations: items.map(function (item) {
        return item.IdLocation;
      }),
    };
    Object.assign(setFilters, locations);

    const page = {
      page: 1,
    };
    Object.assign(setFilters, page);
    self.setState({ filters: setFilters });
  }

  handleOnChangeAutocompleteStatus(event, item) {
    let self = this;
    let setFilters = self.state.filters;
    const idStatus = {
      idStatus: typing.isEmpty(item.id) ? null : item.id,
    };
    Object.assign(setFilters, idStatus);

     const page = {
      page: 1,
    };
    Object.assign(setFilters, page);
    self.setState({ filters: setFilters });
  }

  handleCloseMenuOptions(option) {
    this.setState({ anchorEl: null });
  }

  handleOpenMenuOptions(event) {
    let self = this;
    self.setState({ anchorEl: event.currentTarget });
  }

  handleSelectCustomDates() {
    let self = this;
    self.setState({ anchorEl: null, textDate: "Custom range" });
  }

  handleSelectDates(selected) {
    let self = this;

    let cursorDate = new Date();
    let beginDate = new Date();
    let endDate = new Date();

    cursorDate.setMonth(cursorDate.getMonth() - 1);
    const firstOfThisMonth = new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      1
    );
    let textDate = "";
    switch (selected) {
      case 0:
        beginDate = null;
        endDate = null;
        textDate = "All Dates";
        break;
      case 1:
        beginDate = firstOfThisMonth;
        endDate = new Date();
        textDate = "This month";
        break;
      case 2:
        beginDate = new Date(
          cursorDate.getFullYear(),
          cursorDate.getMonth(),
          1
        );
        endDate = new Date(firstOfThisMonth - 1);
        textDate = "Last month";
        break;
      case 3:
        beginDate = new Date(new Date().getFullYear(), 0, 1);
        endDate = new Date();
        textDate = "This year"; 
        break;
      case 4:
        beginDate = new Date(new Date().getFullYear() - 1, 0, 1);
        endDate = new Date(new Date().getFullYear() - 1, 11, 31);
        textDate = "Last year";
        break;
      case 5:
        beginDate = new Date();
        endDate = new Date();
        textDate = "Today";
        break;
      case 6:
        beginDate = new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000);
        endDate = new Date();
        textDate = "Last 7 days";
        break;
      default:
        beginDate = new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000);
        endDate = new Date();
        textDate = "Last 7 days";
    }

    let setFilters = self.state.filters;
    const beginDateFilter = {
      beginDate: beginDate,
    };
    Object.assign(setFilters, beginDateFilter);
    const endDateFilter = {
      endDate: endDate,
    };
    Object.assign(setFilters, endDateFilter);

    const page = {
      page: 1,
    };
    Object.assign(setFilters, page);

    self.setState({
      anchorEl: null,
      textDate: textDate,
      filters: setFilters,
    });
  }

  handleBeginDateChange(event) {
    let self = this;
    let setFilters = self.state.filters;
    const beginDate = {
      beginDate: event.target.value,
    };
    Object.assign(setFilters, beginDate);

    const page = {
      page: 1,
    };
    Object.assign(setFilters, page);

    self.setState(
      {
        filters: setFilters,
        textDate: "Custom range",
      },
      function () {
        if (
          !typing.isObject(self.state.filters.beginDate) &&
          !typing.isEmpty(self.state.filters.beginDate) &&
          !typing.isObject(self.state.filters.endDate) &&
          !typing.isEmpty(self.state.filters.endDate)
        ) {
          self.setState({ anchorEl: null });
        }
      }
    );
  }

  handleEndDateChange(event) {
    let self = this;
    let setFilters = self.state.filters;
    const endDate = {
      endDate: event.target.value,
    };
    Object.assign(setFilters, endDate);

    const page = {
      page: 1,
    };
    Object.assign(setFilters, page);

    self.setState(
      {
        filters: setFilters,
        textDate: "Custom range",
      },
      function () {
        if (
          !typing.isObject(self.state.filters.beginDate) &&
          !typing.isEmpty(self.state.filters.beginDate) &&
          !typing.isObject(self.state.filters.endDate) &&
          !typing.isEmpty(self.state.filters.endDate)
        ) {
          self.setState({ anchorEl: null });
        }
      }
    );
  }

  handleOnClickFilters(event, items) {
    let self = this;
    self.handleOnChangeRefreshResultListDebounce(self.state.filters);
  }

  render() {
    let self = this;
    const {
      classes,
      categoryResult,
      keywordsResult,
      keywordsFoundResult,
      locations,
      filters,
      filtersPending,
    } = self.props;
    const { anchorEl, textDate } = this.state;
    return (
      <Paper elevation={0} className={classes.paper} square={true}>
        {!filtersPending && (
          <Fragment>
          <Grid
            container
            direction="row"
            justifycontent="space-between"
            alignItems="baseline"
            spacing={1}
          >
            <Grid item xs={12}>
              <Grid container direction="row" alignItems="flex-end" spacing={1}>
                <Grid item xs={12}>
                  <TextField
                    id="filled-search"
                    label="Search"
                    type="search"
                    onChange={this.handleOnChangeTextFieldSearch.bind(this)}
                    onKeyDown={this.handleOnKeyDownTextFieldSearch.bind(this)}
                    size="small"
                    value={this.props.filters.domain}
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchOutlined />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} className={classes.rowHeader}>
              <Grid container direction="row" alignItems="flex-end" spacing={1}>
                <Grid item xs={12}>
                  <Autocomplete
                    id="combo-status"
                    disableListWrap={true}
                    disableClearable={true}
                    autoComplete={false}
                    options={Constants.SUPPLIER_JOB_STATUS.filter(
                      (x) => x.showDropdown === true
                    )}
                    getOptionLabel={(option) => option.value}
                    value={
                      Constants.SUPPLIER_JOB_STATUS.filter(
                        (x) => x.id === filters.idStatus
                      )[0]
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Status"
                        variant="outlined"
                        size="small"
                        fullWidth
                      />
                    )}
                    onChange={this.handleOnChangeAutocompleteStatus.bind(this)}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Autocomplete
                    multiple
                    id="combo-categories"
                    options={categoryResult}
                    disableCloseOnSelect
                    getOptionLabel={(option) => option.CATEGORY}
                    onChange={this.handleOnChangeAutocompleteCategory.bind(
                      this
                    )}
                    renderOption={(option, { selected }) => (
                      <React.Fragment>
                        <Checkbox
                          icon={checkicon}
                          color="default"
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 5 }}
                          checked={selected}
                        />
                        {option.CATEGORY}
                      </React.Fragment>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="Categories"
                        size="small"
                        fullWidth
                      />
                    )}
                    onInputChange={this.handleOnInputChangeAutocompleteCategory.bind(
                      this
                    )}
                    defaultValue={
                      this.props.filters.categories.length > 0
                        ? this.props.filters.categories
                        : []
                    }
                  />
                </Grid>
                <Grid item xs={12}>
                  <Autocomplete
                    multiple
                    id="combo-keywords"
                    options={keywordsResult}
                    disableCloseOnSelect
                    getOptionLabel={(option) => option.KEYWORD}
                    onChange={this.handleOnChangeAutocompleteKeyword.bind(this)}
                    renderOption={(option, { selected }) => (
                      <React.Fragment>
                        <Checkbox
                          icon={checkicon}
                          color="default"
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 5 }}
                          checked={selected}
                        />
                        {option.KEYWORD}
                      </React.Fragment>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="Keywords Found"
                        size="small"
                        fullWidth
                      />
                    )}
                    onInputChange={this.handleOnInputChangeAutocompleteKeyword.bind(
                      this
                    )}
                    defaultValue={
                      this.props.filters.keywords.length > 0
                        ? this.props.filters.keywords
                        : []
                    }
                  />
                </Grid>
                <Grid item xs={12}>
                  <Autocomplete
                    multiple
                    id="combo-keywords-found"
                    options={keywordsFoundResult}
                    disableCloseOnSelect
                    getOptionLabel={(option) => option.KEYWORD}
                    onChange={this.handleOnChangeAutocompleteKeywordFound.bind(
                      this
                    )}
                    renderOption={(option, { selected }) => (
                      <React.Fragment>
                        <Checkbox
                          icon={checkicon}
                          color="default"
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 5 }}
                          checked={selected}
                        />
                        {option.KEYWORD}
                      </React.Fragment>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="Researched keywords"
                        size="small"
                        fullWidth
                      />
                    )}
                    onInputChange={this.handleOnInputChangeAutocompleteKeywordFound.bind(
                      this
                    )}
                    defaultValue={
                      this.props.filters.keywordsFound.length > 0
                        ? this.props.filters.keywordsFound
                        : []
                    }
                  />
                </Grid>
                <Grid item xs={12}>
                  <Autocomplete
                    multiple
                    disableListWrap={true}
                    disableClearable={false}
                    autoComplete={true}
                    id="combo-locations"
                    options={locations}
                    getOptionLabel={(option) => option.Description}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Locations"
                        variant="outlined"
                        size="small"
                        fullWidth
                      />
                    )}
                    onChange={this.handleOnChangeAutocompleteLocations.bind(
                      this
                    )}
                    defaultValue={locations.filter(function (item) {
                      return (
                        self.props.filters.locations.indexOf(item.IdLocation) >
                        -1
                      );
                    })}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Button
                    aria-controls="simple-menu"
                    className={classes.buttomFilter}
                    variant="outlined"
                    aria-haspopup="true"
                    onClick={this.handleOpenMenuOptions.bind(this)}
                    size="large"
                    fullWidth
                  >
                    {textDate}
                  </Button>
                  <Menu
                    className={classes.menuDateTime}
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    PopoverClasses={{ paper: classes.popoverPaper }}
                    onClose={this.handleCloseMenuOptions.bind(this)}
                  >
                    <MenuItem onClick={this.handleSelectDates.bind(this, 0)}>
                      All Dates
                    </MenuItem>
                    <Divider />
                    <MenuItem onClick={this.handleSelectDates.bind(this, 5)}>
                      Today
                    </MenuItem>
                    <MenuItem onClick={this.handleSelectDates.bind(this, 6)}>
                      Last 7 days
                    </MenuItem>
                    <MenuItem onClick={this.handleSelectDates.bind(this, 1)}>
                      This month
                    </MenuItem>
                    <MenuItem onClick={this.handleSelectDates.bind(this, 2)}>
                      Last month
                    </MenuItem>
                    <MenuItem onClick={this.handleSelectDates.bind(this, 3)}>
                      This year
                    </MenuItem>
                    <MenuItem onClick={this.handleSelectDates.bind(this, 4)}>
                      Last year
                    </MenuItem>
                    <Divider />
                    <ListItemText className={classes.itemText}>
                      Custom range
                    </ListItemText>
                    <Divider />
                    <ListItemText>
                      <div style={{}}>
                        <TextField
                          variant="outlined"
                          label="From"
                          type="date"
                          size="small"
                          className={classes.textDate}
                          value={self.props.filters.beginDate}
                          onChange={this.handleBeginDateChange.bind(this)}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />

                        <TextField
                          variant="outlined"
                          label="To"
                          type="date"
                          size="small"
                          className={classes.textDate}
                          value={self.props.filters.endDate}
                          onChange={this.handleEndDateChange.bind(this)}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </div>
                    </ListItemText>
                  </Menu>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Button
                variant="contained"
                color="primary"
                size="large"
                onClick={self.handleOnClickFilters.bind(this)}
                fullWidth
              >
                FILTER
              </Button>
            </Grid>         
          </Grid>
          </Fragment>
        )}
      </Paper>
    );
  }
}

FilterIdentifySupplierJobs.propTypes = {
  classes: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  const categoryResult = state.IdentifySupplierJobsReducers.categoryResult;
  const keywordsResult = state.IdentifySupplierJobsReducers.keywordsResult;
  const keywordsFoundResult =
    state.IdentifySupplierJobsReducers.keywordsFoundResult;
  const locations = state.IdentifySupplierJobsReducers.locations;
  const filters = state.IdentifySupplierJobsReducers.filters;
  const filtersPending = state.IdentifySupplierJobsReducers.filtersPending;
  return {
    filters,
    categoryResult,
    keywordsResult,
    keywordsFoundResult,
    locations,
    filtersPending,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    setFiltersAndGetList: (filters) => {
      return dispatch(
        IdentifySupplierJobsActions.setFiltersAndGetList(filters)
      );
    },
    getCategories: (Category) => {
      return dispatch(IdentifySupplierJobsActions.getCategories(Category));
    },
    getKeywords: (keyword) => {
      return dispatch(IdentifySupplierJobsActions.getKeywords(keyword));
    },
    getKeywordsFound: (keyword) => {
      return dispatch(IdentifySupplierJobsActions.getKeywordsFound(keyword));
    },
    getLocations: () => dispatch(IdentifySupplierJobsActions.getLocations()),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(filterIdentifySupplierJobsStyle)(FilterIdentifySupplierJobs));
